import { render, staticRenderFns } from "./OnboardingStepWhyDidYouRegister.vue?vue&type=template&id=21943446"
import script from "./OnboardingStepWhyDidYouRegister.vue?vue&type=script&lang=js"
export * from "./OnboardingStepWhyDidYouRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports